
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/[name]",
      function () {
        return require("private-next-pages/services/[name].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/[name]"])
      });
    }
  